import styled, { css } from 'styled-components';
import { Select } from '@zillow/constellation';

import AutoComplete from 'app/shared/components/Autocomplete';

export const StyledAutoComplete = styled(AutoComplete)`
    float: none;
`;

export const StyledSelect = styled(Select)`
    ${props => props.theme &&
    props.theme.ns &&
    css`
    color: ${props.theme.ns().colors.gray500};
    `}
`;
